<andor-tabs [tabs]="tabs" [(active)]="activeTab"></andor-tabs>
@if (activeTab().id === 'dark') {
  <andor-settings-theme mode="dark"></andor-settings-theme>
} @else {
  <andor-settings-theme mode="light"></andor-settings-theme>
}
